import { apiClient } from '@/lib/api/client';

export interface RoundRobinSettings {
  id: string;
  organization_id: string;
  is_enabled: boolean;
  current_index: number;
}

export interface RoundRobinAgent {
  user_id: string;
  id: string;
  name: string;
  avatar_url?: string;
  role: string;
  is_online?: boolean;
  round_robin_enabled?: boolean;
  /** users.is_active — TeamRepository.findByOrganizationId already selects this. */
  is_active?: boolean;
}

export const roundRobinApi = {
  getSettings: () =>
    apiClient.get<{ success: boolean; data: RoundRobinSettings }>('/round-robin/settings'),

  updateSettings: (payload: { is_enabled: boolean }) =>
    apiClient.put<{ success: boolean; data: RoundRobinSettings }>('/round-robin/settings', payload),

  getAgents: () =>
    apiClient.get<{ success: boolean; data: RoundRobinAgent[] }>('/round-robin/agents'),

  updateAgent: (userId: string, round_robin_enabled: boolean) =>
    apiClient.put<{ success: boolean }>(`/round-robin/agents/${userId}`, { round_robin_enabled }),
};
